module.exports = __webpack_public_path__ + "img/tool.2a5dbbd2.png";